import {
  HeadingText,
  ParagraphText,
  Modal,
  ImageMessage,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import errorImg from 'assets/error-icon.svg';
import { BaseModalContainer } from 'components/modals/common/base-modal.component';
import { ModalActionButton } from './common/modal-action-button.component';

export const AccountDeletedModal = () => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(queryHelpers.only('mobile'));

  return (
    <BaseModalContainer
      footer={
        <ModalActionButton
          actionType="submit"
          labelId="STR_I_UNDERSTAND"
          isMobile={isMobile}
          cssStyle={{
            background: '$primaryBackgroundDefault',
            alignSelf: 'flex-end',
            marginBlockStart: '$two',
            borderRadius: '62px',
          }}
        />
      }
    >
      <ImageMessage
        image={errorImg}
        css={{ flexGrow: 1, padding: '$two $none' }}
      >
        {/* @ts-ignore */}
        <Modal.Title>
          <HeadingText
            level="2"
            size="lg"
            css={{ marginBlock: '$one', fontWeight: 'bold' }}
          >
            {formatMessage({ id: 'STR_ACCOUNT_DELETED_TITLE' })}
          </HeadingText>
        </Modal.Title>
        <ParagraphText>
          {formatMessage({ id: 'STR_ACCOUNT_DELETED_BODY_1' })}
        </ParagraphText>
        <ParagraphText>
          {formatMessage({ id: 'STR_ACCOUNT_DELETED_BODY_2' })}
        </ParagraphText>
      </ImageMessage>
    </BaseModalContainer>
  );
};
